export default function createTablePalette(theme, current, base) {
    return {
        table: {
            cell: {
                backgroundColor: "inherit",
                svg: {
                    color: base.gray[500],
                },
            },
            head: {
                color: current.contrast[500],
                backgroundColor: current[500],
            },
            headOverlay: {
                backgroundColor: current[500],
            },
            row: {
                backgroundColor: base.background,
                borderColor: base.gray[200],
                highlighted: {
                    backgroundColor: base.gray[50],
                },
                selected: {
                    backgroundColor: current[500],
                },
                thead: {
                    color: current.contrast[500],
                    backgroundColor: current[500],
                },
            },
        },
    };
}
//# sourceMappingURL=table.js.map